import { type ReactNode } from "react";

/**
 * Tiny uppercase monospace label used throughout the Transceiver UI —
 * e.g. `MIC`, `OUT`, `POLICY`, `GATE` (spec §2.13).
 *
 * Rendered as a pair: small grey label, then the value.
 */
export function MonoLabel({
  label,
  children,
  className = "",
}: {
  label: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={`font-mono text-[11px] tracking-wider ${className}`}>
      <span className="text-subtext">{label}</span>
      <span className="mx-1.5 text-subtext">·</span>
      <span className="text-ink">{children}</span>
    </span>
  );
}
